import { createSelector } from 'reselect';
import _ from 'lodash';

import { getHistoryState } from './utils';

const getState = state => state;

const getEntities = createSelector(getState, state => state.entities);

export const getAllSuppliersHash = createSelector(
  getEntities,
  state => state.entities.suppliers
);

const getOrders = createSelector(
  getHistoryState,
  state => state.entities.orders
);

const getItemsHash = createSelector(
  getHistoryState,
  state => state.entities.order_items
);

export const getOrder = createSelector(
  getOrders, (__, orderId) => orderId, (orders, orderId) => orders[orderId]
);

export const getItemsForOrder = createSelector(
  getItemsHash,
  getOrder,
  (itemsLookup, order) => {
    if (!order) {
      return [];
    }

    return _.map(
      order.supplierorderitems,
      soi_id => itemsLookup[soi_id]
    );
  }
);

export const getOrdersFetchingTrackers = createSelector(
  getOrders,
  orders => _.filter(
    orders,
    'areTrackersFetching'
  )
);
